import {
    Directive,
    ElementRef,
    Output,
    EventEmitter,
    HostListener, OnInit
} from '@angular/core';
import { fromEvent } from 'rxjs';
import { take } from 'rxjs/operators';
  
@Directive({
    selector: '[ClickOutside]'
})
export class ClickOutsideDirective implements OnInit {
    @Output() ClickOutside = new EventEmitter();
  
    captured = false;
  
    constructor(private elRef: ElementRef) { }
  
    @HostListener('document:click', ['$event.target'])
    onClick(target: any): void{
        if (!this.captured) {
            return;
        }
  
        if (!this.elRef.nativeElement.contains(target)) {
            this.ClickOutside.emit();
        }
    }
  
    ngOnInit(): void {
        fromEvent(document, 'click', { capture: true }).pipe(take(1))
            .subscribe(() => this.captured = true);
    }
}
